import request from '../axios'

/**
 * 职位管理API模块
 */
const jobAPI = {
  /**
   * 获取职位列表
   * @param {Object} params - 查询参数
   * @param {number} params.page - 页码
   * @param {number} params.pageSize - 每页数量
   * @returns {Promise} - 返回Promise对象
   */
  getJobList(params) {
    return request({
      url: '/jobs/list',
      method: 'GET',
      params
    })
  },

  /**
   * 根据ID获取职位详情
   * @param {number} jobId - 职位ID
   * @returns {Promise} - 返回Promise对象
   */
  getJobById(jobId) {
    return request({
      url: `/jobs/${jobId}`,
      method: 'GET'
    })
  },

  /**
   * 添加职位
   * @param {Object} data - 职位数据
   * @param {string} data.title - 职位名称
   * @param {string} data.location - 工作地点
   * @param {string} data.description - 职位内容
   * @returns {Promise} - 返回Promise对象
   */
  addJob(data) {
    return request({
      url: '/jobs',
      method: 'POST',
      data
    })
  },

  /**
   * 更新职位
   * @param {number} jobId - 职位ID
   * @param {Object} data - 职位数据
   * @param {string} [data.title] - 职位名称
   * @param {string} [data.location] - 工作地点
   * @param {string} [data.description] - 职位内容
   * @returns {Promise} - 返回Promise对象
   */
  updateJob(jobId, data) {
    return request({
      url: `/jobs/${jobId}`,
      method: 'PUT',
      data
    })
  },

  /**
   * 删除职位
   * @param {number} jobId - 职位ID
   * @returns {Promise} - 返回Promise对象
   */
  deleteJob(jobId) {
    return request({
      url: `/jobs/${jobId}`,
      method: 'DELETE'
    })
  },

  /**
   * 提交职位申请
   * @param {Object} applicationData - 申请表单数据
   * @param {string} applicationData.jobId - 职位ID
   * @param {string} applicationData.name - 申请人姓名
   * @param {string} applicationData.email - 邮箱
   * @param {string} applicationData.education - 学历
   * @param {string} applicationData.phone - 电话
   * @param {string} [applicationData.selfIntroduction] - 自我介绍
   * @param {string} [applicationData.availableDate] - 可入职日期
   * @param {string} [applicationData.resumeUrl] - 简历URL
   * @param {string} [applicationData.coverLetterUrl] - 求职信URL
   * @returns {Promise} - 返回Promise对象
   */
  submitApplication(applicationData) {
    return request({
      url: '/jobApplications',
      method: 'POST',
      data: applicationData
    })
  }
}

export default jobAPI